import { createFeature, createReducer, on } from '@ngrx/store';
import { navigationActions } from './navigation.actions';

export interface AlternativeBackButtonConfiguration {
  url: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryParams?: any;
  name: string;
}

export interface State {
  alternativeBackButton: AlternativeBackButtonConfiguration | null;
}

export const initialRouterState: State = {
  alternativeBackButton: null,
};
export const navigationFeature = createFeature({
  name: 'navigation',
  reducer: createReducer(
    initialRouterState,
    on(navigationActions.setAlternativeBackNavigationButton, (state, action) => ({
      ...state,
      alternativeBackButton: action.alternativeBackButton,
    })),
  ),
});
